import React from 'react'
import { MapMetric } from '../services/map-metrics.service'
import { Col, Row } from 'antd'
import { MapYear } from '../services/map-municipalities.service'

type Props = {
  metric: MapMetric,
  year?: MapYear,
}

export const MapMeta: React.FC<Props> = ({ metric, year }) => {
  return (
    <div className="db-search-card">
      <h1>Más información sobre {metric.name}</h1>

      <Row>
        <Col span={12}>
          <h2>Año</h2>
          {year?.name}
        </Col>
        <Col span={12}>
          <h2>Periodicidad</h2>
          {metric.periodicity}
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <h2>Unidades</h2>
          {metric.unit || 'N/A'}
        </Col>
        <Col span={12}>
          {!!metric.sources?.length && (
            <>
              <h2>Fuentes</h2>
              <ul>
                {metric.sources.map((s, index) => (
                  <li key={index}>
                    <a href={s.link} target="_blank" rel="noopener noreferrer">
                      {s.name}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          )}
        </Col>
      </Row>
      {!!metric.description &&
        <>
          <h2>Descripción</h2>
          <Row style={{ marginTop: 12 }}>
            <Col span={24}>{metric.description}</Col>
          </Row>
        </>
      }
    </div>
  )
}